import { useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { GridColumn, Grid } from '@progress/kendo-react-grid';
import { withState } from '../../../../components/common/grid/WrappedGrid';
import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import { API_URL } from '../../../../utils/constants';
import GridWrapper from '~/src/components/common/GridWrapper';
import createIcon from '../../../../static/img/createIcon.svg';

export default function WarehouseOwnerList(): JSX.Element {
  const stateRef = useRef(null);
  const history = useHistory();
  const url = `${API_URL}/contractors/warehouse-owners/get`;
  const StatefullGrid = withState(Grid, url);

  const countryCell = (p) => {
    return <td>{p?.dataItem?.contractor?.country?.name}</td>;
  };

  const productNameCell = (row) => {
    const { dataItem } = row;

    return (
      <td>
        <Link to={`/warehouse-owners/edit/${dataItem.id}`}>{dataItem?.name}</Link>
      </td>
    );
  };

  return (
    <WhitePad>
      <TitleComponent
        title="Warehouse Owners"
        titleRight="Create"
        onRightHandler={(): void => history.push('/warehouse-owners/create')}
        iconRight={createIcon}
        titleLeft="Back"
        onLeftHandler={(): void => history.goBack()}
      />
      <GridWrapper>
        <StatefullGrid ref={stateRef}>
          <GridColumn field="name" title="Customer Name" cell={(row) => productNameCell(row, stateRef)} />
          <GridColumn field="countryId" title="Country" cell={countryCell} />
        </StatefullGrid>
      </GridWrapper>
    </WhitePad>
  );
}
